import { createEntityBundle } from '@common/utils'

const invoiceBundle = createEntityBundle({ name: 'property_invoices' })

export default invoiceBundle
